import React from 'react';
import {
  Typography,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Chip,
  Tooltip,
} from '@material-ui/core';
import { Rating } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import profile from '../../assets/profile.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    marginTop: theme.spacing(2),
    minHeight: 80,
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  content: {
    flex: '1 0 auto',
    padding: theme.spacing(1, 2, 1),

    '&:last-child': {
      paddingBottom: theme.spacing(1),
    },
  },
  cover: {
    width: 62,
    objectFit: 'contain',
    backgroundColor: theme.palette.primary.main,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  cardName: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.2,
    padding: theme.spacing(0),
    alignSelf: 'top',
  },
  cardCompany: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: 1.2,
    padding: theme.spacing(0),
    alignSelf: 'top',
  },
  reviewTag: {
    fontWeight: 600,
    margin: theme.spacing(1, 1, 0, 0),
  },
}));

function ReviewTag({ label, tooltip }) {
  const { reviewTag } = useStyles();

  return (
    <Tooltip
      title={tooltip}
      disableFocusListener={!tooltip}
      disableHoverListener={!tooltip}
      disableTouchListener={!tooltip}
      interactive
    >
      <Chip
        label={label}
        color="primary"
        variant="outlined"
        size="small"
        className={reviewTag}
      />
    </Tooltip>
  );
}

export default function ReviewCard({ review }) {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardMedia
        className={classes.cover}
        component="img"
        image={profile}
        title="Profile"
      />
      <div className={classes.details}>
        <CardContent className={classes.content}>
          <div className={classes.header}>
            <Grid container fluid>
              <Grid align="left" md={8}>
                <Typography className={classes.cardName} component="h3">
                  {review.submitterFirstName}
                  {' '}
                  {review.submitterLastName}
                </Typography>
                <Typography className={classes.cardCompany} component="h4" color="textSecondary">
                  {review.submitterCompanyName}
                </Typography>
              </Grid>
              <Grid align="right" md={4}>
                <Rating value={review.rating} readOnly />
              </Grid>
            </Grid>
          </div>
          <div className={classes.tags}>
            { (review.excellentGuest) ? <ReviewTag label="Excellent Guest (EG)" /> : '' }
            { (review.chargeback) ? <ReviewTag label="Chargeback" /> : '' }
            { (review.petPolicyViolation) ? <ReviewTag label="Pet Policy Violation" /> : '' }
            { (review.occupancyPolicyViolation) ? <ReviewTag label="Occupancy Policy Violation" /> : '' }
            { (review.negativeReview)
              ? <ReviewTag label="Negative Review" tooltip={review.commentNegativeReview} />
              : '' }
            { (review.propertyDamage)
              ? <ReviewTag label="Property Damage" tooltip={review.commentPropertyDamage} />
              : '' }
            { (review.noisePolicyViolation)
              ? <ReviewTag label="Noise Policy Violation" tooltip={review.commentNoisePolicyViolation} />
              : '' }
            { (review.nonCompliance)
              ? <ReviewTag label="Non-Compliance" tooltip={review.commentNonCompliance} />
              : '' }
          </div>
        </CardContent>
      </div>
    </Card>
  );
}
